import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
const KEY = "endag1_compare";
const MAX = 3;

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const toggle = (product) => {
    setItems((prev) => {
      if (prev.find((p) => p.slug === product.slug)) {
        return prev.filter((p) => p.slug !== product.slug);
      }
      if (prev.length >= MAX) {
        toast.error(`Compare up to ${MAX} compounds at once.`);
        return prev;
      }
      return [...prev, product];
    });
  };

  const remove = (slug) => setItems((prev) => prev.filter((p) => p.slug !== slug));
  const clear = () => setItems([]);
  const has = (slug) => items.some((p) => p.slug === slug);

  return (
    <CompareContext.Provider value={{ items, toggle, remove, clear, has, max: MAX }}>
      {children}
    </CompareContext.Provider>
  );
}

export const useCompare = () => useContext(CompareContext);
